export default __webpack_public_path__ + "static/media/block-mill.de82ed30.svg";